import React from 'react';

import { getAppStore } from '../../bootstrap/redux/store/AppStore';
import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../commonInfra/utils/ImgUrl';
import { DraftBanner, DraftBannerAction } from '../../drafts/components/DraftBanner';
import { ISpaceItemDetailInfo } from '../../spacesPlatform/models/ISpaceItemDetailInfo';
import { deleteFlowDraft } from '../actions/DeleteFlowDraftReduxAction';
import { editFlow } from '../actions/EditFlowReduxAction';

export type FlowDraftBannerProps = {
  readonly flow: ISpaceItemDetailInfo<'flow'>;
};

export function FlowDraftBanner(props: FlowDraftBannerProps): JSX.Element {
  if (!props.flow || !props.flow.flowDraft) {
    return null;
  }

  const handleEditFlow = () => {
    if (props?.flow) {
      getAppStore().dispatch(editFlow(props.flow));
    }
  };

  const handleDeleteDraft = () => {
    if (props?.flow) {
      getAppStore().dispatch(deleteFlowDraft([props.flow]));
    }
  };

  const getContinueEditBannerAction: () => DraftBannerAction = () => ({
    label: Messages.continueEditing(),
    handleAction: handleEditFlow,
    iconPath: imgPath('pencil_14px_small.svg'),
    testId: 'continue-editing'
  });

  const getDeleteDraftBannerAction: () => DraftBannerAction = () => ({
    label: Messages.deleteDraft(),
    handleAction: handleDeleteDraft,
    iconPath: imgPath('trash_14px_small.svg'),
    testId: 'delete-draft'
  });

  return (
    <DraftBanner
      lastEditDate={props.flow.flowDraft.lastUpdatedAt}
      draftBannerActions={[getContinueEditBannerAction(), getDeleteDraftBannerAction()]}
      contentTypeName={Messages.lastEditedFlow()}
    />
  );
}
